import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      ssr: true,
    },
  },
  {
    path: '/profile',
    name: 'dashboard',
    component: Dashboard,
    // component: () =>
    //   import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: {
      ssr: true,
    },
    children: [
      {
        name: 'application',
        path: 'application',
      },
      {
        name: 'details',
        path: 'details',
      },
    ],
  },
]

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    routes,
  })

export default createRouter
